import { useEffect, useState } from "react";
import axios from "../../../axios";
import { toast } from "react-toastify";
import DeletePasswordModal from "../../../componant/DeletePasswordModal";

const categories = [
  "PSC",
  "Teaching",
  "Police",
  "SSC",
  "Railway",
  "Banking",
  "Defence",
  "UPSC",
  "Other",
];

const initialForm = {
  examName: "",
  examNameHin: "",
  category: "",
  course: "",
  // state: "",
  // isNational: false,
};

export default function AddExam() {
  const [states, setStates] = useState([]);
  const [courses, setCourses] = useState([]);
  const [exams, setExams] = useState([]);
  const [activeTab, setActiveTab] = useState("create");
  const [form, setForm] = useState(initialForm);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleteExamId, setDeleteExamId] = useState(null);

  useEffect(() => {
    getStates();
    getCourses();
    getExams();
  }, []);

  const getStates = async () => {
    try {
      const res = await axios.get("/all");
      setStates(res.data?.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const getCourses = async () => {
    try {
      const res = await axios.get("/getAllCoursesForAdmin");
      setCourses(res.data?.result || []);
    } catch (err) {
      console.log(err);
      toast.error("Courses load nahi ho paye");
    }
  };

  const getExams = async () => {
    try {
      const res = await axios.get("/exams/all");
      setExams(res.data?.result || res.data?.data || []);
    } catch (err) {
      console.log(err);
      toast.error("Exams load nahi ho paye");
    }
  };

  const resetForm = () => {
    setForm(initialForm);
    setEditingId(null);
  };

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
      ...(name === "isNational" && checked ? { state: "" } : {}),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        ...form,
        // state: form.isNational ? "" : form.state,
      };

      if (editingId) {
        await axios.put(`/exams/edit/${editingId}`, payload);
        toast.success("Exam Updated Successfully");
      } else {
        await axios.post("/exams/add", payload);
        toast.success("Exam Added Successfully");
      }

      resetForm();
      getExams();
      setActiveTab("view");
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (exam) => {
    setForm({
      examName: exam.examName || "",
      examNameHin: exam.examNameHin || "",
      category: exam.category || "",
      course: exam.course?._id || exam.course || "",
      // state: exam.state?._id || exam.state || "",
      // isNational: exam.isNational === true,
    });
    setEditingId(exam._id);
    setActiveTab("create");
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/exams/delete/${id}`);
      toast.success("Exam Deleted Successfully");
      getExams();
    } catch (err) {
      toast.error(err.response?.data?.message || "Exam delete nahi ho paya");
    }
  };

  const getCourseName = (exam) => {
    if (exam.course?.planName) return exam.course.planName;

    const courseId = exam.course?._id || exam.course;
    const course = courses.find((item) => item._id === courseId);

    return course?.planName || "-";
  };

  // const getStateName = (exam) => {
  //   if (exam.isNational) return "National";
  //   if (exam.state?.fullName) return exam.state.fullName;

  //   const stateId = exam.state?._id || exam.state;
  //   const state = states.find((item) => item._id === stateId);

  //   return state?.fullName || "-";
  // };

  return (
    <div className="min-h-screen bg-bgWhite px-4 py-6">
      <div className="mx-auto max-w-6xl">
        <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="font-oswald text-2xl font-bold text-purple">
              Exam Management
            </h2>
            <p className="text-sm text-gray-600">
              Create exams, assign them to courses, and manage the exam list.
            </p>
          </div>
        </div>

        <div className="mb-5 rounded-lg border border-gray-200 bg-white p-1 shadow-sm">
          <div className="grid grid-cols-2 gap-1">
            <button
              type="button"
              className={`rounded-md px-4 py-3 text-sm font-semibold transition ${
                activeTab === "create"
                  ? "bg-purple text-white shadow"
                  : "text-gray-700 hover:bg-gray-100"
              }`}
              onClick={() => setActiveTab("create")}
            >
              {editingId ? "Edit Exam" : "Create Exam"}
            </button>
            <button
              type="button"
              className={`rounded-md px-4 py-3 text-sm font-semibold transition ${
                activeTab === "view"
                  ? "bg-purple text-white shadow"
                  : "text-gray-700 hover:bg-gray-100"
              }`}
              onClick={() => {
                setActiveTab("view");
                getExams();
              }}
            >
              View Exam
            </button>
          </div>
        </div>

        {activeTab === "create" ? (
          <div className="rounded-lg border border-gray-200 bg-white p-5 shadow-sm">
            <div className="mb-5 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
              <div>
                <h3 className="text-lg font-semibold text-bgBlue">
                  {editingId ? "Edit Exam" : "Add New Exam"}
                </h3>
                <p className="text-sm text-gray-600">
                  Select category and course so the exam is mapped correctly.
                </p>
              </div>

              {editingId && (
                <button
                  type="button"
                  className="rounded border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700"
                  onClick={resetForm}
                >
                  Cancel Edit
                </button>
              )}
            </div>

            <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">
                  Exam Name
                </label>
                <input
                  className="w-full rounded border border-gray-300 px-3 py-2 outline-none focus:border-purple"
                  name="examName"
                  value={form.examName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">
                  Category
                </label>
                <select
                  className="w-full rounded border border-gray-300 px-3 py-2 outline-none focus:border-purple"
                  name="category"
                  value={form.category}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">
                  Course
                </label>
                <select
                  className="w-full rounded border border-gray-300 px-3 py-2 outline-none focus:border-purple"
                  name="course"
                  value={form.course}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Course</option>
                  {courses.map((course) => (
                    <option key={course._id} value={course._id}>
                      {course.planName}
                    </option>
                  ))}
                </select>
              </div>

              {/* <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">
                  State
                </label>
                <select
                  className="w-full rounded border border-gray-300 px-3 py-2 outline-none focus:border-purple disabled:bg-gray-100"
                  name="state"
                  value={form.state}
                  onChange={handleChange}
                  disabled={form.isNational}
                >
                  <option value="">Select State</option>
                  {states.map((state) => (
                    <option key={state._id} value={state._id}>
                      {state.fullName}
                    </option>
                  ))}
                </select>
              </div>

              <label className="flex items-center gap-2 text-sm font-medium text-gray-700 md:col-span-2">
                <input
                  type="checkbox"
                  className="h-4 w-4"
                  checked={form.isNational}
                  name="isNational"
                  onChange={handleChange}
                />
                National Exam
              </label> */}

              <div className="flex gap-3 md:col-span-2">
                <button
                  type="submit"
                  disabled={loading}
                  className="rounded bg-purple px-5 py-2 font-semibold text-white disabled:opacity-70"
                >
                  {loading ? "Saving..." : editingId ? "Update Exam" : "Save Exam"}
                </button>
                <button
                  type="button"
                  className="rounded border border-gray-300 px-5 py-2 font-semibold text-gray-700"
                  onClick={resetForm}
                >
                  Reset
                </button>
              </div>
            </form>
          </div>
        ) : (
          <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="flex flex-col gap-2 border-b border-gray-200 p-5 md:flex-row md:items-center md:justify-between">
              <div>
                <h3 className="text-lg font-semibold text-bgBlue">View Exams</h3>
                <p className="text-sm text-gray-600">
                  Total exams: {exams.length}
                </p>
              </div>
              <button
                type="button"
                className="rounded border border-bgBlue px-4 py-2 text-sm font-semibold text-bgBlue"
                onClick={getExams}
              >
                Refresh
              </button>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full text-left text-sm">
                <thead className="bg-gray-50 text-xs uppercase text-gray-600">
                  <tr>
                    <th className="px-4 py-3">Sr No.</th>
                    <th className="px-4 py-3">Exam Name</th>
                    <th className="px-4 py-3">Category</th>
                    <th className="px-4 py-3">Course</th>
                    {/* <th className="px-4 py-3">State</th> */}
                    {/* <th className="px-4 py-3">Type</th> */}
                    <th className="px-4 py-3 text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {exams.map((exam, index) => (
                    <tr key={exam._id || index} className="border-t hover:bg-gray-50">
                      <td className="px-4 py-3 text-gray-600">{index + 1}</td>
                      <td className="px-4 py-3 font-semibold text-gray-900">
                        {exam.examName || "-"}
                      </td>
                      <td className="px-4 py-3">
                        <span className="rounded-full bg-purple/10 px-3 py-1 text-xs font-semibold text-purple">
                          {exam.category || "-"}
                        </span>
                      </td>
                      <td className="px-4 py-3">{getCourseName(exam)}</td>
                      {/* <td className="px-4 py-3">{getStateName(exam)}</td> */}
                      {/* <td className="px-4 py-3">
                        <span
                          className={`rounded-full px-3 py-1 text-xs font-semibold ${
                            exam.isNational
                              ? "bg-green-100 text-green-700"
                              : "bg-blue-100 text-blue-700"
                          }`}
                        >
                          {exam.isNational ? "National" : "State"}
                        </span>
                      </td> */}
                      <td className="px-4 py-3">
                        <div className="flex justify-end gap-2">
                          <button
                            type="button"
                            className="rounded bg-bgBlue px-3 py-2 text-xs font-semibold text-white"
                            onClick={() => handleEdit(exam)}
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="rounded bg-red-600 px-3 py-2 text-xs font-semibold text-white"
                            onClick={() => setDeleteExamId(exam._id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}

                  {!exams.length && (
                    <tr>
                      <td className="px-4 py-8 text-center text-gray-500" colSpan="7">
                        No exams found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <DeletePasswordModal
        isOpen={Boolean(deleteExamId)}
        onClose={() => setDeleteExamId(null)}
        onConfirm={() => handleDelete(deleteExamId)}
        title="Delete Exam"
        description="Password verify hone ke baad exam delete hoga."
      />
    </div>
  );
}
